import React, { FC } from 'react';
import { Row as AntdRow } from 'antd';
import { RowProps } from 'antd/lib/grid';

export const Row: FC<RowProps> = (props) => {
  return <AntdRow {...props} />;
};
export default Row;
